import React, { useMemo } from 'react';

import {
    AuthAppFlow,
    TwoFactorAuthRequirePopup,
    TwoFactorExpiredPopup,
    TwoFactorModalPopup,
    TwoFactorPopupType,
} from '@pkg/components/2FA';
import { useAppSelector } from '@pkg/hooks';

import { useAuthTokens } from '@app/store/zustand/Auth/useUserTokens';

export function TwoFAPopups() {
    const isAuthenticated = useAuthTokens((state) => state.isAuthenticated);

    const requirePopup = useAppSelector((state) => state.twoFactorAuth.requirePopup);
    const postPurchasePopup = useAppSelector((state) => state.twoFactorAuth.postPurchasePopup);
    const setupFlow = useAppSelector((state) => state.twoFactorAuth.setupFlow);
    const expiredLogin = useAppSelector((state) => state.twoFactorAuth.expiredLogin);
    const on2faNext = useAppSelector((state) => state.twoFactorAuth.on2faNext);
    const showMintingPopup = useAppSelector((state) => state.twoFactorAuth.showMintingPopup);
    const showArtifactMintingPopup = useAppSelector((state) => state.twoFactorAuth.showArtifactMintingPopup);

    const twoFAPopups = useMemo(() => {
        if (isAuthenticated) {
            if (requirePopup) return <TwoFactorAuthRequirePopup />;

            if (postPurchasePopup) return <TwoFactorModalPopup />;

            if (setupFlow) return <AuthAppFlow />;

            if (showMintingPopup) return <TwoFactorModalPopup type={TwoFactorPopupType.Minting} />;

            if (showArtifactMintingPopup) return <TwoFactorModalPopup type={TwoFactorPopupType.ArtifactMinting} />;
        }
        if (expiredLogin) return <TwoFactorExpiredPopup on2faNext={on2faNext} />;
    }, [
        expiredLogin,
        isAuthenticated,
        on2faNext,
        postPurchasePopup,
        requirePopup,
        setupFlow,
        showMintingPopup,
        showArtifactMintingPopup,
    ]);

    return <>{twoFAPopups}</>;
}
